import React, { useEffect } from 'react'
import NavbarTop from './../components/global/NavbarTop';
// import Footer from './../components/global/Footer';
// import NavbarBottom from './../components/global/NavbarBottom';
import AllFeaturesContent from '../components/AllFeatures/AllFeaturesContent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/language/selector';

const AllFeatures = () => {
  
  const {t} = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('all-features-page.all-features-page-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  return (
    <>
        <NavbarTop/>
        <AllFeaturesContent/>
        {/* <Footer/>
        <NavbarBottom/> */}
    </>
  )
}

export default AllFeatures